import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";

import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Botonera";
import BotoneraWithFooter from "./BotoneraWithFooter";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";



const BotoneraInfoGral = () => {
    const navigate = useNavigate();
    const [lugar, setLugar] = useState({lugar: "123"});

    const changeHandler = (e) => {
        const { name, value } = e.target;
        //alert("monos");
        setLugar({
          ...lugar,
          [name]: value,
        });
        //alert(patente).;
      };

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamiento")}}/>
       <EstacionamientoSmallHeader texto="Info general" retorno="/estacionamiento"/>
       <div class="row">
                <div class="col">
                    <img src="./mapan_infogeneral-04.svg" class="imgContentMain"/>
                </div>
            </div>
       <div class="row">
                <div class="col smallSubtitle">
                    D&iacute;as y horarios
                </div>
            </div>
       <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <h1 className="buttonBotoneraDanger"> Zona Centro: 
                        <br/> Lunes a Viernes de 8 a 19hs <br/> S&aacute;bados de 8 a 13hs</h1>
                    </div>
                </div>
            </div>
       
        </div>
        <Botonera/>    
        
       
        
        
        </>

    );
    }
export default BotoneraInfoGral;